import { render } from "./ProfileTable.vue?vue&type=template&id=9034fbc4&scoped=true"
import script from "./ProfileTable.vue?vue&type=script&lang=js"
export * from "./ProfileTable.vue?vue&type=script&lang=js"

import "./ProfileTable.vue?vue&type=style&index=0&id=9034fbc4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9034fbc4"]])

export default __exports__